module.exports = __webpack_public_path__ + "img/order10.79ffab79.svg";